import { nanoid } from 'nanoid/async'
import { sequenceModal } from './sequenceModal'
import { updateNodeConnections } from '../../utils/functions'

// eslint-disable-next-line
export default async (node, editor) => {
  const oldData = node.data
  const { value: sequenceData } = await sequenceModal(oldData, node)

  if (sequenceData && Object.values(sequenceData).length > 0) {
    if (! ('uniqueId' in node.data)) {
      const data = {
        uniqueId: await nanoid(36),
      }

      Object.assign(node.data, data)
    }

    Object.assign(node.data, sequenceData)
    node.update()
    updateNodeConnections(node)
  }

  return false
}